import {
  VERB_TENSES,
  VERB_CATEGORY,
  VERB_PERSON,
  VERB_NUMBER,
  VOWELS,
  SAMPLE_VERBS,
  VERB_FORMS
} from "@/constants.js";

import {
  conjugate,
  generateStem,
  enumerateConjugations,
  allFormsOfWord,
  removeAsterisk
} from "@/conjugation.js";
import shuffle from "shuffle-array";
import { VERB_QUESTION_TYPES } from "./constants";
const tenses = Object.values(VERB_TENSES);
const persons = Object.values(VERB_PERSON);
const numbers = Object.values(VERB_NUMBER);
const categories = Object.values(VERB_CATEGORY);
const verbs = Object.values(SAMPLE_VERBS);
const tensesNoSubjunctive = tenses.slice(0, 4).concat(tenses.slice(5));
const indepdendentForm = "Independent"
const questionTypes = [
  "parameters to conjugation",
  "conjugation to parameters",
  "translation to conjugation",
  "conjugation to translation",
]

function getRandomWord(wordSet) {
  if (wordSet) return _.sample(wordSet);
  else return _.sample(verbs);
}

function getRandomTense(tenseSet) {
  if(tenseSet) return _.sample(tenseSet)
  else return _.sample(tenses);
}

function getRandomForm(formSet) {
  if(formSet) return _.sample(formSet)
  else return _.sample(VERB_FORMS);
}

function getRandomCategory(catSet) {
  if(catSet) return _.sample(catSet)
  else return _.sample(categories);
}

function getWordFromCategory(category) {
  return _.sample(verbs.filter(w => w.cat === category));
}

export function promptSetByCategory(chosenCategory, length = 5) {
  var result = [];
  for (var i = 0; i < length; i++) {
    //if word not specified but category is, choose random word that matches the chosen category
    if (chosenCategory) {
      result = result.concat(
        tablePrompt(
          getWordFromCategory(chosenCategory),
          getRandomTense(),
          getRandomForm()
        )
      );
    } else {
      console.error("No category specified");
    }
  }
  return result;
}

export function promptSetByTense(chosenTense, length) {
  var result = [];
  for (var i = 0; i < length; i++) {
    if (chosenTense) {
      result = result.concat(
        tablePrompt(getRandomWord(), chosenTense, getRandomForm())
      );
    } else {
      console.error("No tense specified");
    }
  }
  return result;
}

function getPromptObj(setSpecifications){
  var cat = setSpecifications.categories ?  getRandomCategory(setSpecifications.categories) : getRandomCategory();
  var tense = setSpecifications.tenses ? getRandomTense(setSpecifications.tenses) : getRandomTense();
  var form = tense === tenses.subjunctive ? indepdendentForm : getRandomForm(setSpecifications.forms);
  return {
    word: getWordFromCategory(cat),
    tense: tense,
    form: form,
    type: _.sample(setSpecifications.types)
  }
}

//Verb Lesson set should contain a question about each table cell for each category
export function generateLessonVerbSet(setSpecifications){
  var result = [];
  setSpecifications.tenses.forEach(tense => {
    setSpecifications.categories.forEach(cat => {
      var table = tablePrompt(getWordFromCategory(cat),tense,getRandomForm(setSpecifications.forms))
      table.map(x => x.type = _.sample(VERB_QUESTION_TYPES))
      result = result.concat(table);
    })
  })
  return result;
}

export function generatePaleoSet(setSpecifications,length){
  
}

export function generatePromptSet(setSpecifications, length) {
  console.log(setSpecifications);
  var result = [];
  var promptList = new Set();
  for (var i = 0; i < length; i++) {
    var obj = getPromptObj(setSpecifications)
    while(promptList.has(obj)){
      obj = getPromptObj(setSpecifications)
    }
    promptList.add(obj)
    var table = tablePrompt(obj.word,obj.tense,obj.form)
    table.map(x => x.type = obj.type)
    result = result.concat(table);
  }
  return shuffle(result).slice(0,length);
}

function tablePrompt(word, tense, form) {
  var result = [];
  numbers.forEach(number => {
    persons.forEach(person => {
      var prompt = generatePrompt(word, tense, number, person, form);
      if(prompt) result.push(prompt);
    })
  })
  return result;
}

function generatePrompt(word, tense, number, person, form) {
  var answers;
  var stem = generateStem(word.verb,word.cat,tense)
  answers = conjugate(person, number, word.cat, tense, form, stem);
  if(!answers) return;
  answers = answers.map(allFormsOfWord).flat();
  answers = answers.map(removeAsterisk);
  var verb = word.verb;
  var res = {
    category: word.cat,
    verb: verb,
    person: person,
    number: number,
    tense: tense,
    depForm: form,
    answers: answers
  };
  return res;
}

export function randomConjugationPrompt(chosenWord) {
  var word = chosenWord ? chosenWord : _.sample(SAMPLE_VERBS);
  var cat = word.cat;
  var verb = word.verb;
  var person = _.sample(Object.values(VERB_PERSON));
  var tense = cat === "irregular" ? _.sample(word.tables).tense : _.sample(Object.values(VERB_TENSES));
  var number = _.sample(Object.values(VERB_NUMBER));
  var depForm = _.sample(VERB_FORMS);
  if (tense === VERB_TENSES.subjunctive) depForm = VERB_FORMS.independent;
  var stem = generateStem(word.verb, cat, tense);
  var answers = conjugate(person, number, cat, tense, depForm, stem);
  answers = answers.map(allFormsOfWord).flat();
  answers = answers.map(removeAsterisk);
  while(tense == VERB_TENSES.subjunctive && depForm != VERB_FORMS.independent ||
        tense == VERB_TENSES.interrogative && depForm == VERB_FORMS.interrogative){
    var tense = _.sample(Object.values(VERB_TENSES));
    var depForm = _.sample(VERB_FORMS); 
  }
  var res = {
    category: cat,
    verb: verb,
    person: person,
    number: number,
    tense: tense,
    depForm: depForm,
    answers: answers,
    stem: stem
  };
  return res;
}
